import apiClient from '../services/apiClient.js';

class AuthService {
  constructor() {
    this.currentUser = null;
  }
  
  async getCurrentUser() {
    if (this.currentUser) {
      return this.currentUser;
    }
    
    try {
      const sessionHash = this.getSessionHash();
      if (!sessionHash) return null;
      
      const result = await apiClient.get('/users');
      if (result && Array.isArray(result)) {
        this.currentUser = { 
          session_valid: true,
          session_hash: sessionHash
        };
        return this.currentUser;
      }
      return null;
    } catch (error) {
      this.clearSession();
      return null;
    }
  }
  
  async isAuthenticated() {
    const user = await this.getCurrentUser();
    return !!user;
  }
  
  async requireAuth() {
    const isAuth = await this.isAuthenticated();
    if (!isAuth) {
      window.location.href = 'signin.html';
      return false;
    }
    return true;
  }
  
  async logout() {
    try {
      const sessionHash = this.getSessionHash();
      if (sessionHash) {
        await apiClient.post('/users/logout', { session_hash: sessionHash });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      this.clearSession();
      window.location.href = 'signin.html';
    }
  }
  
  clearSession() {
    this.currentUser = null;
    sessionStorage.removeItem('session_hash');
  }
  
  getSessionHash() {
    return sessionStorage.getItem('session_hash');
  }
  
  setSessionHash(hash) {
    sessionStorage.setItem('session_hash', hash);
  }
  
  async getUserType() {
    const sessionHash = this.getSessionHash();
    if (!sessionHash) return null;
    
    try {
      const users = await apiClient.get('/users');
      return 'super_user';
    } catch (error) {
      return null;
    }
  }
  
  async isSuperUser() {
    const userType = await this.getUserType();
    return userType === 'super_user';
  }
  
  async hasAdminAccess() {
    return await this.isSuperUser();
  }
}

const authService = new AuthService();
export default authService;
